import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/actions-runner/_work/website/website/components/GenericHero/GenericHero.js");
;
import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/components/PillarModules/PillarModules.scss");
;
import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/components/PillarHeroVisual/PillarHeroVisual.scss");
;
import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/components/CTA/CTA.scss");
;
import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/website/website/node_modules/next/dist/client/link.js");
